
import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import NetworkStatusIndicator from './components/add-ons/NetworkStatusIndicator'
import { CartCountProvider } from './components/context/UserCartCountContext'
import reportWebVitals from './reportWebVitals'
import ToastProvider from './Toast/ToastProvider'
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'select2/dist/js/select2.min.js';
import "./index.scss";
import './styles/Toast.css'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <>
    <CartCountProvider>
      <ToastProvider>
        <App />
        <NetworkStatusIndicator />
      </ToastProvider>
    </CartCountProvider>
  </>
);

reportWebVitals()
